const imageExtensions = [".jpg", ".jpeg", ".png", ".webp", ".gif"];

export default function isImageAsset(asset: string | undefined | null): boolean {
  return asset !== undefined && asset !== null && imageExtensions.some((ext) => asset.includes(ext));
}
